import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { PageTitle } from '@/components/seo/page-title';
import { BusinessListPage } from '@/screens/business/business-list-page';

export default function CuisineScreen() {
  const { cuisine } = useLocalSearchParams<{ cuisine?: string }>();
  const cuisineName = typeof cuisine === 'string' ? cuisine : '';

  return (
    <>
      <PageTitle title={cuisineName || 'Cuisine'} />
      <BusinessListPage
        mode="cuisine"
        cuisine={cuisineName}
        title={cuisineName ? cuisineName : 'Cuisine'}
        perPage={50}
      />
    </>
  );
}


